import { useLingui } from '@lingui/react';
import useLanguageStore from './locale';

function useTranslations() {
  const { i18n } = useLingui();
  const { setLocale } = useLanguageStore();

  const changeLanguage = (newLocale: string) => {
    i18n.activate(newLocale);
    setLocale(newLocale);
  };

  return {
    changeLanguage,
  };
}

export default useTranslations;
